import { Inbox } from "lucide-react";

const EmptyState = ({ title = "Chưa có dữ liệu", description }) => (
  <div className="flex flex-col items-center justify-center py-12 text-gray-400">
    <Inbox size={32} className="mb-2" />
    <div className="text-sm font-medium text-gray-600">{title}</div>
    {description && <div className="text-xs mt-1">{description}</div>}
  </div>
);

export default EmptyState;
